// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgPlanet = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <circle cx={10} cy={10} r={6.667} stroke="currentColor" strokeWidth={1.5} />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M14.583 5.29c1.915-.449 3.288-.397 3.615.26.61 1.222-2.632 4.074-7.238 6.371-4.607 2.297-8.836 3.169-9.445 1.947-.326-.655.454-1.78 1.958-3.035"
    />
  </svg>
);
export const PlanetIcon = forwardRef(SvgPlanet);
